import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      configForKey: 'config/configForKey',
    }),
  },
  methods: {
    firstname(name) {
      const c = this.configForKey('app_config').configV2
      if (c.defaultV2 && c.defaultV2.firstnameInitials && name) {
        return name.charAt(0)
      }
      return name
    },
    capitalizeEveryWord(str) {
      const c = this.configForKey('app_config').configV2
      if (c.defaultV2 && c.defaultV2.capitalizeEveryWordInName && str) {
        return str.toLowerCase().replace(/(^|\s)\S|[-.]\s*\S/g, function(firstLetter) {
          return firstLetter.toUpperCase();
      });
      }
      return str
    },
  }
}
